<template>
  <div>
    <section id="things-to-know" class="bg-beige1">
      <h2 class="pt-12 text-center font-Spectral text-[32px] font-medium leading-[40px] tracking-[0.5px] text-[#826B3D] md:pt-7 md:text-4xl md:leading-[48px]">Things to Know</h2>
      <div class="pb-6 pt-2 md:pb-14">
        <div class="mx-auto w-12 border-b border-gold1 md:w-14" />
      </div>
      <div class="px-4 md:mx-[5%] md:px-0 e2:m-auto e2:max-w-6xl">
        <div class="text-base md:px-[8%] lg:m-auto lg:max-w-[832px] lg:p-0">
          <div class="font-Spectral">
            <!-- Things to Know Items -->
            <div v-if="drawerTabs.length > 0" class="mb-6 flex w-full flex-col items-stretch lg:w-[832px]">
              <ThingsToKnowItem v-for="(tab, index) in drawerTabs" :key="index" :has-detail="true" :heading="tab.tabName" :on-open-detail="() => onOpenDrawerTab(index, tab.tabName)" />
            </div>
            <div v-else-if="(experienceCms.thingsToKnow ?? []).length > 0" class="mb-6 flex w-full flex-col items-stretch lg:w-[832px]">
              <ThingsToKnowItem
                v-for="(item, index) in experienceCms.thingsToKnow"
                :key="index"
                :has-detail="!!item.detail"
                :heading="item.heading"
                :on-open-detail="() => openDrawer(index)"
                :summary="item.summary"
              />
            </div>
            <!-- FAQ Section -->
            <div v-if="experienceCms.faq && experienceCms.faq.length > 0" class="border-b border-gray1 py-4">
              <h3 class="font-Spectral text-base font-normal text-gold1">FAQ</h3>
              <div class="mt-2">
                <FaqSection :categorized-faqs="experienceCms.faq" :default-show-count="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Drawer -->
    <ClientOnly>
      <TitledRichTextDrawer :content="selectedItem?.detail" :on-open-change="setDrawerOpen" :open="isDrawerOpen" :title="selectedItem?.heading ?? ''" />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import { extractThingsToKnowDrawerTabs, type EnExperienceViewModel, type ThingsToKnowItem as ThingsToKnowItemType } from '@/models/enExperience';
import ThingsToKnowItem from '@/wabunka-src/features/Experience/pages/ExperienceDetail/components/pure/ThingsToKnowItem/ThingsToKnowItem.vue';
import TitledRichTextDrawer from '@/wabunka-src/features/Experience/pages/ExperienceDetail/components/pure/TitledRichTextDrawer/TitledRichTextDrawer.vue';
import FaqSection from '@/wabunka-src/features/FAQ/components/FaqSection/FaqSection.vue';

interface Props {
  experienceCms: EnExperienceViewModel;
  onOpenDrawerTab: (index: number, label: string) => void;
}
const props = defineProps<Props>();
const drawerTabs = computed(() => extractThingsToKnowDrawerTabs(props.experienceCms));
const isDrawerOpen = ref(false);
const setDrawerOpen = (v: boolean) => {
  isDrawerOpen.value = v;
};
const selectedItemIndex = ref<number | null>(null);
const selectedItem = computed<ThingsToKnowItemType | null>(() => {
  if (selectedItemIndex.value === null) return null;
  return props.experienceCms.thingsToKnow[selectedItemIndex.value] ?? null;
});
const openDrawer = (index: number) => {
  selectedItemIndex.value = index;
  isDrawerOpen.value = true;
};
watch(isDrawerOpen, (value) => {
  if (!value) {
    selectedItemIndex.value = null;
  }
});
</script>
